import { StepSummary } from './step-summary';
import { Step, StepConfig, StepId, StepSection } from '../../ui/form/multi/types';

interface SummaryStepProps {
  baseSteps: Step[];
  stepsConfig: StepConfig;
}

export const SummaryStep = ({ baseSteps, stepsConfig }: SummaryStepProps) => (
  <>
    {baseSteps.map(
      ({ id, label }: Step, index: number) =>
        id !== StepId.SUMMARY && (
          <StepSummary
            key={id}
            index={index}
            stepId={id}
            stepLabel={label}
            sections={stepsConfig[id] as StepSection[]}
          />
        ),
    )}
  </>
);
